// extracted by mini-css-extract-plugin
module.exports = {"quantity":"QuantitySelector_quantity__SXvs8","input":"QuantitySelector_input__DzLtY","action":"QuantitySelector_action__86f85"};